/**
 * L'API IDM a volte risponde con { code, message } invece di { error: { code } }.
 * TeddyAuth legge solo error.code, quindi mostra il messaggio grezzo dell'API.
 * Qui riallineiamo al testo in theme.t.errors.idm (locale Shopify).
 */
function extractIdmErrorCode(payload) {
  if (!payload || typeof payload !== "object") return null;
  const nested = payload.error?.code;
  if (nested != null && nested !== "") return String(nested);
  const resData = payload.response?.data;
  if (resData && typeof resData === "object") {
    const fromRes = resData.error?.code ?? resData.code;
    if (fromRes != null && fromRes !== "") return String(fromRes);
  }
  const flat = payload.code;
  if (flat != null && flat !== "") {
    const s = String(flat);
    if (s.startsWith("ERR_")) return null;
    return s;
  }
  return null;
}

function attachIdmNormalize(host) {
  if (!host || host.dataset.idmNormalize === "1") return;
  host.dataset.idmNormalize = "1";
  host.addEventListener("mc:form:error", (ev) => {
    const code = extractIdmErrorCode(ev.detail);
    if (!code) return;
    const idm = window.theme?.t?.errors?.idm;
    const msg = idm?.[code];
    if (!msg) return;
    queueMicrotask(() => {
      const fe = host.querySelector("mc-form-errors");
      if (fe && typeof fe.showError === "function") fe.showError(msg);
    });
  });
}

function scanTeddyAuthHosts() {
  document.querySelectorAll("teddy-auth-register, teddy-auth-login, teddy-auth-profile, teddy-auth-reset").forEach(attachIdmNormalize);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", scanTeddyAuthHosts);
} else {
  scanTeddyAuthHosts();
}
